import { useLocation } from "react-router-dom";

export interface Crumb {
  label: string;
  href?: string;
}

const LABELS: Record<string, string> = {
  overview: "Überblick",
  orders: "Aufträge",
  stock: "Lager",
  customers: "Kunden",
  invoices: "Rechnungen",
  shipping: "Versand",
  catalog: "Übersicht-Grundartikel",
  inventory: "Bestand",
  "product-knowledge": "Produktwissen",
  "service-cases": "Servicefälle",
  admin: "Admin",
  users: "Benutzer",
  dashboard: "Dashboard",
};

const STOP_AT_KNOWN_PARENT = new Set([
  "orders",
  "stock",
  "customers",
  "invoices",
  "shipping",
  "catalog",
  "inventory",
  "product-knowledge",
]);

export function resolveBreadcrumbs(pathname: string): Crumb[] {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0) return [{ label: "stahlia" }];

  const crumbs: Crumb[] = [{ label: "stahlia", href: "/" }];
  let acc = "";

  segments.forEach((seg, idx) => {
    acc += `/${seg}`;
    const isLast = idx === segments.length - 1;
    const known = LABELS[seg];
    let label: string;
    if (known) label = known;
    else if (isLast && STOP_AT_KNOWN_PARENT.has(segments[idx - 1] ?? "")) label = "Detail";
    else label = seg;
    const isListParent = !isLast && STOP_AT_KNOWN_PARENT.has(seg);
    crumbs.push(isListParent ? { label, href: acc } : { label });
  });

  return crumbs;
}

export function useBreadcrumbs(): Crumb[] {
  const { pathname } = useLocation();
  return resolveBreadcrumbs(pathname);
}
